import { createContext, useContext } from "react";

import { Episode } from "@/types/Episode";
import { Mention } from "@/types/Mention";
import { PaginatedSearchMentions } from "@/types/PaginatedSearchMentions";
import { Search } from "@/types/Search";
import { Tag } from "@/types/Tag";

type EpisodesContextType = {
  meta: PaginatedSearchMentions["meta"] | null;
  loading: boolean;
  episodes: Episode[];
  shareMention: Episode | null;
  errors?: Error[];
  alert: Search | null;
  tag: Tag | undefined;
  updateMention: (mention: Mention) => void;
  deleteEpisode: (episode_uuid: Episode["episode_uuid"]) => void;
  setMentions: (episodes: Episode[]) => void;
  patchEpisode: (
    episode: Partial<Episode> & Required<Pick<Episode, "episode_uuid">>
  ) => void;
  closeShare: () => void;
  share: (mention: Episode) => void;
  // share modal
};

const EpisodesContext = createContext<EpisodesContextType>({
  meta: null,
  loading: true,
  episodes: [],
  alert: null,
  tag: undefined,
  patchEpisode: () => null,
  setMentions: () => null,
  deleteEpisode: () => null,
  updateMention: () => null,
  closeShare: () => null,
  shareMention: null,
  share: () => null,
  // share modal
});

export const useEpisodes = () => useContext(EpisodesContext);
